
import { useState, useEffect } from 'react';

export default function FloatingCTAButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Mostrar el botón después de hacer scroll hacia abajo 300px
      const scrolled = window.scrollY;
      setIsVisible(scrolled > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    // Scroll suave hacia el formulario en la sección programa
    const formularioSection = document.getElementById('formulario-prelanzamiento');
    if (formularioSection) {
      formularioSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <button
        onClick={handleClick}
        className="bg-gradient-to-r from-[#6607a5] to-purple-700 hover:from-purple-700 hover:to-[#6607a5] text-white font-bold py-4 px-6 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap text-sm flex items-center gap-2 animate-pulse hover:animate-none"
      >
        <i className="ri-gift-line text-lg"></i>
        <span>QUIERO FORMAR PARTE</span>
      </button>
    </div>
  );
}
